export const formatJsonText = (value?: string | null): string => {
  if (!value?.trim()) {
    return ''
  }

  try {
    return JSON.stringify(JSON.parse(value), null, 2)
  } catch {
    return value
  }
}

export interface JsonErrorDetail {
  line?: number
  column?: number
  rawMessage: string
}

export const getJsonErrorDetail = (value: string, error: unknown): JsonErrorDetail => {
  const rawMessage = error instanceof Error ? error.message : 'JSON 格式错误'
  const positionMatch = rawMessage.match(/position\s+(\d+)/i)

  if (!positionMatch) {
    return { rawMessage }
  }

  const position = Number(positionMatch[1])

  if (Number.isNaN(position) || position < 0) {
    return { rawMessage }
  }

  const contentBeforeError = value.slice(0, position)
  const lines = contentBeforeError.split('\n')
  const line = lines.length
  const column = (lines[lines.length - 1] || '').length + 1

  return { line, column, rawMessage }
}

export const parseJsonErrorDetail = (value?: string | null): JsonErrorDetail | null => {
  if (!value?.trim()) {
    return null
  }

  try {
    JSON.parse(value)
    return null
  } catch (error) {
    return getJsonErrorDetail(value, error)
  }
}

export const createJsonValidator = (label: string) => async (_: unknown, value?: string) => {
  if (!value?.trim()) {
    return Promise.resolve()
  }

  const errorDetail = parseJsonErrorDetail(value)

  if (!errorDetail) {
    return Promise.resolve()
  }

  if (errorDetail.line) {
    return Promise.reject(new Error(`第 ${errorDetail.line} 行：${label}格式不正确（第 ${errorDetail.column} 列附近）`))
  }

  return Promise.reject(new Error(`${label}格式不正确：${errorDetail.rawMessage}`))
}

export const formatRet00cExampleFields = <T extends Record<string, any> | null | undefined>(record: T): T => {
  if (!record) {
    return record
  }

  return {
    ...record,
    request_example: formatJsonText(record.request_example),
    response_example: formatJsonText(record.response_example),
  }
}
